import $ from "./lib/qsa.js";
import { store } from "./state.js";
import { Map, Marker, GeoJSON, DivIcon, LatLngBounds, TileLayer, Rectangle, Popup } from "leaflet";
import districtStyle from "./districtStyle.js";
import markerFilter from "./markerFilter.js";
import Wherewolf from "wherewolf";
import { mediaValues } from "./mediaQuery.js";

const EMBEDDED = window.top != window;
export const MAX_BOUNDS = [[42.24,-86.9], [41.424,-88.294]];

let mapContainer = $.one(".backdrop .map");
export let map = new Map(mapContainer, {
  maxBounds: MAX_BOUNDS,
  minZoom: 10,
  zoomSnap: .1,
  maxBoundsViscosity: 1,
  scrollWheelZoom: !EMBEDDED,
  // markerZoomAnimation: false,
  dragging: !EMBEDDED,
  zoomControl: false,
  attributionControl: false,
});
map.fitBounds(MAX_BOUNDS);
window.map = map;
// map.zoomControl.setPosition("bottomright");

let tiles = new TileLayer("./assets/synced/tiles/carto_light_nolabels/{z}/{x}/{y}.png", {
  minZoom: 9,
  maxZoom: 13,
  updateWhenZooming: false,
  updateWhenIdle: true,
  attribution: "Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL."
}).addTo(map);

// sin-eater layer for when people click outside of actual features
let city = new Rectangle(MAX_BOUNDS, { fillOpacity: 0, opacity: 0 });
city.addTo(map);
city.on("click", e => {
  store.data.selectedSchool = null;
  store.data.districtNumber = null;
  store.data.userInitiated = true;
});

// load shapefiles
fetch("./assets/districts-20-centroids.geojson").then(r => r.json()).then(json => {
  let geojson = new GeoJSON(json, {
    onEachFeature(feature, layer) {
      // fix this later for interactive coloring
      layer.on("click", e => {
        store.data.districtNumber = feature.properties.sub;
        store.data.selectedSchool = null;
        store.data.userInitiated = true;
      });
      // generate a label marker at the inner X/Y
      let marker = new Marker([feature.properties.cy, feature.properties.cx], {
        interactive: false,
        icon: new DivIcon({
          iconSize: [20, 20],
          className: "district-label",
          html: feature.properties.sub,
        })
      });
      marker.addTo(map);
    },
    style(feature) {
      return districtStyle(store.raw, feature);
    }
  });
  geojson.addTo(map);
  map.fitBounds(geojson.getBounds(), {
    paddingTopLeft: [20, 20],
    paddingBottomRight: [20, 20],
  });
  store.data.districtShapes = geojson;
  let wolf = Wherewolf()
  wolf.add("district", json);
  store.raw.wolf = wolf;
  store.raw.geojson = json;
});

// load schools
fetch("./profiles.json").then(r => r.json()).then(profiles => {
  let markers = [];
  for (let id in profiles) {
    let row = profiles[id];
    let className = ["school dot", row.governance, row.type, row.category, row.isbeDesignation].join(" ");
    let marker = row.marker = new Marker([row.lat, row.lng], {
      riseOnHover: true,
      interactive: true,
      icon: new DivIcon({
        className,
        iconSize: mediaValues.dotSize
      })
    });
    marker.data = row;
    marker.addTo(map);
    marker.on("click", e => {
      store.data.selectedSchool = row;
      store.data.userInitiated = true;
    });
    markers.push(marker);
  }
  store.data.profiles = profiles;
});

// load district demo/enrollment
fetch("./districts.json").then(r => r.json()).then(districts => {
  store.data.districts = districts;
});

// load school enrollment
fetch("./enrollment.json").then(r => r.json()).then(enrollment => {
  store.data.enrollment = enrollment;
});